import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import mTop from "../assets/images/about/macbook-top.svg";
import mCover from "../assets/images/about/macbook-cover.svg";
import about from "../assets/images/about/about.mp4";
import mBottom from "../assets/images/about/macbook-bottom.svg";

const AboutUs = () => {
  return (
    <React.Fragment>
      <section className="section about bg-light" id="about">
        <Container>
          <Row className="text-center">
            <Col lg={12}>
              <div className="sec-hd mb-4">
                <span className="heading"></span>
                <h2 className="sec-title">ABOUT US</h2>
                <span className="heading"></span>
              </div>
            </Col>
            <Col md={10} className="mx-auto">
              <div>
                <p>
                  At Wolbee, we believe that every workplace has the potential
                  to be a thriving, adaptive environment where employees feel
                  valued and empowered. Our mission is to revolutionize employee
                  experience by harnessing the power of AI to provide
                  personalized, intuitive management tools that help businesses
                  and their teams succeed.
                  <br />
                  <br />
                  We bring personalized insights directly to managers, helping
                  them gain a deeper understanding of each employee’s needs,
                  preferences, and performance. We don’t just provide data, we
                  make it actionable. Every day, Wolbee pushes valuable insights
                  to managers, empowering them to make informed decisions and
                  take meaningful actions that drive engagement and
                  productivity.
                  <br />
                  <br />
                  Our tools help managers understand what to do with the data,
                  ensuring they can foster a supportive, high-performing work
                  environment. With Wolbee, managers connect with employees on a
                  deeper level, improving team dynamics and creating adaptive
                  workplaces.
                  <br />
                  <br />
                  The result? Improved engagement, satisfaction, and
                  retention—fostering loyalty, reducing turnover, and driving
                  productivity. Join Wolbee and unlock the full potential of
                  your team with personalized insights that make a difference.
                  <br />
                  <br />
                </p>
              </div>
            </Col>

            <hr className="my-5" />
            <br />
            <Col lg={12}>
              <div className="mockup mockup-macbook loaded opened">
                <div className="part top">
                  <img src={mTop} alt="" className="img-fluid top" />
                  <img src={mCover} alt="" className="img-fluid cover" />
                  <video autoPlay muted controls loop>
                    <source src={about} type="video/mp4" />
                  </video>
                </div>
                <div className="part bottom">
                  <img src={mCover} alt="" className="img-fluid cover" />
                  <img src={mBottom} alt="" className="img-fluid bottom" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AboutUs;
